import styled, { keyframes } from 'styled-components';

import { COLOURS } from '@belong/themes';

export const DotWrapper = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

const flash = keyframes`
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(2);
  }
  70%, 100% {
    transform: scale(1);
  }
`;

const Dot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${COLOURS.BELONG_BLUE};
  animation: ${flash} 1.2s infinite ease-in-out;

  @media (prefers-reduced-motion) {
    animation-duration: 3s;
  }
`;

export const Dot1 = styled(Dot)`
  animation-delay: 0s;
`;
export const Dot2 = styled(Dot)`
  animation-delay: 0.2s;
`;
export const Dot3 = styled(Dot)`
  animation-delay: 0.4s;
`;
